export function toFixedValue(
  num: number,
  fixed: number,
  truncateIfZero: boolean,
): string {
  const intPart = Math.trunc(num);
  const fractPart = num - intPart;
  if (truncateIfZero === true && fractPart === 0) return intPart.toString();

  return num.toFixed(fixed);
}
